import gql from 'graphql-tag';

export const sectionEVAccountInfo = gql`
  fragment sectionEVAccountInfo on SectionEVAccountInfo {
    data {
      address {
        addressLine1
        city
        state
        postal
      }
      useAccountContact
      accountContact {
        firstName
        middleName
        lastName
        phoneNumber
        emailAddress
      }
      preferredContact {
        firstName
        middleName
        lastName
        phoneNumber
        emailAddress
        relationship
      }
      isOwner
      homeType
    }
  }
`;

export const sectionEVRebates = gql`
  fragment sectionEVRebates on SectionEVRebates {
    data {
      rebateEligibility {
        eligible
        rebate {
          amount
          ... on RebateSmartCharging {
            iqdb
            panelUpgrade
            charger
          }
        }
        evRebate {
          ... on RebateSmartCharging {
            amount
            charger
            panelUpgrade
            isHigherDiscount
            iqdb
          }
          ... on RebateEVPulse {
            amount
          }
          ... on RebateBYOC {
            amount
          }
        }
        ineligibilityReason
      }
      availability {
        iqdbEnroll
        smartChargingRebate
      }
      existingEnrollments {
        iqdb
        evPulse {
          vin
        }
        smartCharging {
          serialNo
        }
      }
      iqdb {
        checkEligibility
        houseHoldSize
        grossIncome
        grossIncomeConfirmed
      }
      smartCharging {
        wifiAvailable
        activateChargerInApp
        chargerForExistingVehicle
        continueWithoutRebate
      }
      evPulse {
        connectEVPulseApp
        vinImage
        vin
        chargerForExistingVehicle
        continueWithoutRebate
      }

      confirmed
    }
  }
`;

export const sectionEVChargerSelection = gql`
  fragment sectionEVChargerSelection on SectionEVChargerSelection {
    data {
      suppliedByCustomer
      productId
    }
  }
`;

export const sectionEVInstallation = gql`
  fragment sectionEVInstallation on SectionEVInstall {
    data {
      schedulePreference {
        urgency
        dayOfWeek
        timeFrame
        preferredServiceTime
      }
      panelLocation {
        location
        comment
      }
      chargerInstallPreference {
        panelSideLocation
        distanceToPanel
        installerRecommendPanelDistance
        installLocation
      }
    }
  }
`;

export const sectionEVPanelInfo = gql`
  fragment sectionEVPanelInfo on SectionEVPanelInfo {
    data {
      panelImage
      panelImageUrl
      amperageImage
      amperageImageUrl
      panelLocationImage
      panelLocationImageUrl
      installDistance {
        extendedInstallDistance
        extendedInstallDistanceImage
        extendedInstallDistanceImageUrl
      }
      breakerInfo {
        mainBreakerAmperage
        doubleBreakerAvailable
      }
      chargerCost
      receiptImage
      receiptImageUrl
    }
  }
`;

export const sectionEVSummary = gql`
  fragment sectionEVSummary on SectionEVSummary {
    data {
      confirmed
    }
  }
`;

export const sectionEVEstimate = gql`
  fragment sectionEVEstimate on SectionEVEstimate {
    data {
      acknowledgedInstallerInfo
      acknowledgedEstimate
      lineItems {
        key
        name
        ... on LineItemCost {
          category
          amount
        }
        ... on LineItemProduct {
          value
          amount
        }
        ... on LineItemProgram {
          value
        }
        ... on LineItemRebate {
          amount
        }
      }
      ineligibleEstimateReason
      subtotal
      total
    }
  }
`;

/** This is where we should tie in all of the EV application sections */
//TODO: ...sectionEVRebates needs to be added
export const sectionEVFragment = gql`
  fragment sectionEVFragment on SectionEV {
    sectionType
    ...sectionEVAccountInfo
    ...sectionEVChargerSelection
    ...sectionEVRebates
    ...sectionEVInstallation
    ...sectionEVPanelInfo
    ...sectionEVSummary
    ...sectionEVEstimate
  }
  ${sectionEVAccountInfo}
  ${sectionEVChargerSelection}
  ${sectionEVRebates}
  ${sectionEVInstallation}
  ${sectionEVPanelInfo}
  ${sectionEVSummary}
  ${sectionEVEstimate}
`;

export const sectionFragment = gql`
  fragment sectionFragment on ApplicationSection {
    id
    status
    errors {
      code
      message
    }

    ...sectionEVFragment
  }

  ${sectionEVFragment}
`;
